import { SLUGS } from '@motorway/mw-enquiry-states/static';
import { useDecision } from '@optimizely/react-sdk';

import { DISABLE_DECISION, FLAG } from 'Utilities/analytics/optimizely/constants';

export const LIVE_AUCTION_ELIGIBLE_STATES: ReadonlyArray<string> = [
  SLUGS.READY_FOR_SALE,
  SLUGS.SALE_ACTIVE,
];

type UseLiveAuctionFlagProps = {
  dpEnquiryId?: number | null;
  enquiryStateSlug?: string | null;
};

export const useLiveAuctionFlag = ({ dpEnquiryId, enquiryStateSlug }: UseLiveAuctionFlagProps) => {
  const isEligible = Boolean(dpEnquiryId)
    && Boolean(enquiryStateSlug)
    && LIVE_AUCTION_ELIGIBLE_STATES.includes(enquiryStateSlug as string);

  const [{ enabled, variationKey }, clientReady] = useDecision(
    FLAG.LIVE_AUCTION_BANNER,
    { decideOptions: isEligible ? [] : DISABLE_DECISION },
    { overrideUserId: dpEnquiryId?.toString() ?? '' },
  );

  return isEligible && clientReady && enabled && variationKey === 'on';
};
